module.exports = __webpack_public_path__ + "img/tooth2.e9a4aa0e.png";